import BuildingUpdateComponent, {
  BuildingUpdateComponentProps,
} from './BuildingUpdateComponent';

export default BuildingUpdateComponent;

export type { BuildingUpdateComponentProps };
